import {Component, OnInit, Input, ChangeDetectionStrategy} from '@angular/core';

import {NotificationMessage} from './notification-message.model';

@Component({
    selector: 'qnect-decline-notification',
    templateUrl: './decline-notification.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DeclineNotificationComponent implements OnInit {

  @Input()
  messages: NotificationMessage[] = [];
  @Input() showPreamble: boolean = true;

  constructor() {
  }

  ngOnInit() {
  }

}
